import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import styles from "./style";
import Logo from "../../Assets/Images/Logo.png";
import Url from "../../Services/Url";
import helmet from "../../Assets/Images/helmet_.png";
import Time from "../../Services/Time";

const PdfDoc = ({ children, report, logo }) => {
	console.log(report);
	const {
		initial,
		logs,
		debrief,
		taskEquipment,
		startedByEngineer,
		finishedByEngineer,
	} = report;
	const task = children;
	const leadEngr = task.taskEngineers.find((e) => e.lead).engineer;
	const operation = task.ownerOperation
		? task.ownerOperation
		: task.taskOperations[0];
	const chucks = (arr, size) =>
		Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
			arr.slice(i * size, i * size + size)
		);
	return (
		<Document style={styles.document}>
			<Page size="A4" style={styles.page}>
				<View style={styles.header}>
					<Text style={{ marginLeft: 60, fontWeight: "bold" }}>Job Report</Text>
					<Image style={styles.logo} src={Logo}></Image>
					<View style={styles.background}>
						<Image style={styles.logo} src={helmet} />
					</View>
				</View>
				<View style={styles.body}>
					<View style={styles.section}>
						<Text style={styles.subheading}>Company Name:</Text>
						<View style={styles.valueBox}>
							<Text style={styles.valueText}>
								{task.vessel?.company_name || task.company?.name}
							</Text>
						</View>
					</View>
					<View style={styles.group}>
						<View style={{ ...styles.section, ...styles.groupItem }}>
							<Text style={styles.subheading}>Job Number:</Text>
							<View style={styles.valueBox}>
								<Text style={styles.valueText}>{task.jobNumber}</Text>
							</View>
						</View>
						<View style={{ ...styles.section, ...styles.groupItem }}>
							<Text style={styles.subheading}>Service Location:</Text>
							<View style={styles.valueBox}>
								<Text style={styles.valueText}>{task.location}</Text>
							</View>
						</View>
						{task.vessel && (
							<View style={{ ...styles.section, ...styles.groupItem }}>
								<Text style={styles.subheading}>Vessel Name:</Text>
								<View style={styles.valueBox}>
									<Text style={styles.valueText}>{task.vessel?.name}</Text>
								</View>
							</View>
						)}
					</View>
					<View style={styles.section}>
						<Text style={styles.subheading}>Service Type:</Text>
						<View style={styles.valueBox}>
							{report.taskEquipment.length > 0 ? (
								report.taskEquipment.map((e) => (
									<Text style={styles.valueText} key={e.id}>
										{e.type.name + " of " + e.name}
									</Text>
								))
							) : (
								<Text style={styles.valueText}>--- ---</Text>
							)}
						</View>
					</View>
					<View style={styles.group}>
						<View
							style={{ ...styles.section, ...styles.groupItem, width: "50%" }}
						>
							<Text style={styles.subheading}>Service Authorized By:</Text>
							<View style={styles.valueBox}>
								<Text style={styles.valueText}>
									{operation.firstname + " " + operation.lastname}
								</Text>
							</View>
						</View>
						<View
							style={{ ...styles.section, ...styles.groupItem, width: "50%" }}
						>
							<Text style={styles.subheading}>Service Engineer:</Text>
							<View style={styles.valueBox}>
								<Text style={styles.valueText}>
									{leadEngr.firstname + " " + leadEngr.lastname}
								</Text>
							</View>
						</View>
					</View>
					<View style={styles.group}>
						<View style={{ ...styles.section, width: "50%" }}>
							<Text style={styles.subheading}>Started On:</Text>
							<View style={styles.valueBox}>
								{startedByEngineer ? (
									<Text style={styles.valueText}>
										{Time.getDateTime(startedByEngineer)}
									</Text>
								) : (
									<Text style={styles.valueText}>–</Text>
								)}
							</View>
						</View>
						<View style={{ ...styles.section, width: "50%" }}>
							<Text style={styles.subheading}>Finished On:</Text>
							<View style={styles.valueBox}>
								{finishedByEngineer ? (
									<Text style={styles.valueText}>
										{Time.getDateTime(finishedByEngineer)}
									</Text>
								) : (
									<Text style={styles.valueText}>–</Text>
								)}
							</View>
						</View>
					</View>
					<View style={styles.section}>
						<Text style={styles.subheading}>Initial State:</Text>
						<View style={styles.valueBox}>
							<Text style={styles.valueText}>
								{initial.details || "--- ---"}
							</Text>
							{initial.images.length > 0 && (
								<View style={{ marginTop: "10px" }}>
									{chucks(initial.images, 2).map((ImgGroup, index) => (
										<View
											style={{ ...styles.group, ...styles.imgGroup }}
											key={index}
										>
											{ImgGroup.map((img) => (
												<View style={styles.groupItemImg} key={img.id}>
													<Image
														style={styles.Img}
														src={Url.img.get(img.uploadId)}
													></Image>
												</View>
											))}
										</View>
									))}
								</View>
							)}
						</View>
					</View>
					<View style={styles.section}>
						<Text style={styles.subheading}>Work Performed:</Text>
						<View style={styles.valueBox}>
							{logs.map((log) => (
								<View key={log.id}>
									{log.jobDoneList.map((job, index) => (
										<View key={index} style={styles.listItem}>
											<View style={styles.listMarker} />
											<Text key={index} style={styles.valueText}>
												{job.details}
											</Text>
										</View>
									))}
									{chucks(log.images, 3).map((ImgGroup, index) => (
										<View
											wrap={false}
											key={index}
											style={{
												...styles.group,
												...styles.imgGroup,
												marginTop: "10px",
											}}
										>
											{ImgGroup.map((img) => (
												<View style={styles.groupItemImg} key={img.id}>
													<Image
														style={styles.Img}
														src={Url.img.get(img.uploadId)}
													/>
												</View>
											))}
										</View>
									))}
									<View style={{ marginVertical: "5px" }}>
										<Text
											style={{
												...styles.subheading,
												marginTop: "15px",
												marginBottom: "5px",
											}}
										>
											Observation:{" "}
										</Text>
										<View style={{ marginLeft: "10px" }}>
											{log.observation.length > 0 ? (
												log.observation.split("\n").map((line, index) => {
													if (line.length > 0 && !(line.trim() === "")) {
														return (
															<View
																wrap={false}
																key={index}
																style={styles.listItem}
															>
																<View style={styles.listMarker} />
																<Text style={styles.valueText}>{line}</Text>
															</View>
														);
													}
													return null;
												})
											) : (
												<Text style={styles.valueText}>--- ---</Text>
											)}
										</View>
									</View>
								</View>
							))}
						</View>
					</View>
					<View style={styles.section}>
						<Text style={styles.subheading}>Debrief:</Text>
						<View style={styles.valueBox}>
							<View style={styles.listItem}>
								<View style={styles.listMarker} />
								<Text style={styles.valueText}>
									Result: {!debrief.result && "--- ---"}
								</Text>
							</View>
							<Text
								style={{
									...styles.valueText,
									fontWeight: "heavy",
									marginLeft: "15px",
								}}
							>
								{debrief.result}
							</Text>

							<View style={styles.listItem}>
								<View style={styles.listMarker} />
								<Text style={styles.valueText}>
									Note: {!debrief.notes && "--- ---"}
								</Text>
							</View>
							<Text
								style={{
									...styles.valueText,
									fontWeight: "heavy",
									marginLeft: "15px",
								}}
							>
								{debrief.notes}
							</Text>

							<View style={styles.listItem}>
								<View style={styles.listMarker} />
								<Text style={styles.valueText}>
									Part(s) Replaced: {!(debrief.parts.lenght > 0) && "--- ---"}
								</Text>
								<View>
									{debrief.parts.length > 0
										? debrief.parts.map((part, index) => (
												<Text
													style={{ ...styles.valueText, fontWeight: "heavy" }}
													key={index}
												>
													{index + 1}. {part.name}
												</Text>
										  ))
										: "--- ---"}
								</View>
							</View>
						</View>
					</View>
					<View style={styles.group} wrap={false}>
						<View style={{ ...styles.section, ...styles.groupItem }}>
							<Text style={styles.subheading}>Work Approved By:</Text>
							<View style={styles.valueBox}>
								<Text style={styles.valueText}>{""}</Text>
							</View>
						</View>
						<View style={{ ...styles.section, ...styles.groupItem }}>
							<Text style={styles.subheading}>Position:</Text>
							<View style={styles.valueBox}>
								<Text style={styles.valueText}>{""}</Text>
							</View>
						</View>
						<View style={{ ...styles.section, ...styles.groupItem }}>
							<Text style={styles.subheading}>Sign/Stamp:</Text>
							<View style={styles.valueBox}>
								<Text style={styles.valueText}>{""}</Text>
							</View>
						</View>
					</View>
				</View>
			</Page>
		</Document>
	);
};

export default PdfDoc;
